import { Box } from 'rebass';
import React, { useContext } from 'react';
import styled from 'styled-components';

import { StoryContext } from '../pages/story';
import StoryPage from './StoryPage';
import useEntity from './hooks/useEntity';

const StyledBox = styled(Box)`
  max-width: 600px;
  /* used for carousel */
  .slider-control-bottomcenter {
    position: relative !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    ul {
      top: 0 !important;
    }
    circle {
      fill: ${props => props.theme.colors.brand} !important;
    }
  }
`;

const StoryPages = props => {
  const id = useContext(StoryContext);
  const story = useEntity({ id, type: 'stories' });

  return (
    <StyledBox mx="auto" {...props}>
      {story.pages.map(page => <StoryPage id={page.id} key={page.id} />).filter(page => !!page)}
    </StyledBox>
  );
};

export default StoryPages;
